import { useQuery } from '@tanstack/react-query';
import { getAuthState } from './api';

export const AUTH_STATE_KEY = ['auth-state'];

export function useAuthState() {
  return useQuery({ queryKey: AUTH_STATE_KEY, queryFn: getAuthState, retry: 1 });
}
